import { Component, OnInit } from '@angular/core';
import { Widget, WidgetMap, WidgetMapType, WidgetSunstudy } from '../../../models/widget';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WidgetMapBackground } from '../create-map-modal/create-map-modal.component';
import { WidgetMapService } from '../../widget-map.service';
import { ActiveModal } from '../../../core/modal.service';
import { FileUploader } from 'ng2-file-upload';
import { SunstudyService } from '../../sunstudy.service';
import { Auth } from '../../../auth/auth.service';
import { WidgetMapUploadResponse } from '../widget-map-upload/widget-map-upload.component';
import { Project } from '../../../models/project';

@Component({
  selector: 'cw-edit-map-modal',
  templateUrl: './edit-map-modal.component.html',
  styleUrls: ['./edit-map-modal.component.scss']
})
export class EditMapModalComponent implements OnInit {
  form: FormGroup;
  uploader: FileUploader = new FileUploader({});
  widget: Widget;
  map: WidgetMap;
  sunstudy: WidgetSunstudy;
  sunstudiesPromise: Promise<{}>;
  sunstudies: WidgetSunstudy[];
  imagePreviewUrl: string;
  mapTypes: WidgetMapType[] = [
    WidgetMapType.Objects,
    WidgetMapType.Maps,
    WidgetMapType.Projects
  ];
  isUploading: boolean = false;

  constructor(private fb: FormBuilder,
              private activeModal: ActiveModal,
              private auth: Auth,
              private sunstudyService: SunstudyService,
              private mapService: WidgetMapService) {
    this.form = this.fb.group({
      type: ['', Validators.required],
      name: ['', Validators.required],
      width: ['', Validators.required],
      height: ['', Validators.required],
      project: ['', null],
      background: this.fb.group({
        fileId: [{ value: '' }, null],
        info: [{ disabled: true, value: '' }, null],
        type: [WidgetMapBackground.Image, Validators.required],
        sunstudyId: ['', null],
      })
    });

    this.form.get('background.sunstudyId').valueChanges.subscribe(sunstudyId => {
      if (sunstudyId) {
        this.sunstudiesPromise.then(() => {
          this.sunstudy = this.sunstudies.find(s => s.id === +sunstudyId);
          this.form.patchValue({
            width: this.sunstudy.width,
            height: this.sunstudy.height,
          });
        });
      }
    });
  }

  onUploadComplete(response: WidgetMapUploadResponse) {
    this.form.patchValue({
      width: response.dimensions.width,
      height: response.dimensions.height,
      background: {
        fileId: response.fileId
      }
    });

    this.imagePreviewUrl = response.previewUrl;
  }

  ngOnInit() {
  }

  private updateModel() {
    const value = this.form.value;

    this.map.type = value.type;
    this.map.name = value.name;

    if (value.background.type === WidgetMapBackground.Sunstudy) {
      this.map.sunstudy = this.getSunstudy(value.background.sunstudyId);
    } else {
      this.map.sunstudy = null;
      this.map.fileId = value.background.fileId ? value.background.fileId : null;
    }

    if (value.project) {
      this.map.project = new Project({ id: value.project });
    } else {
      this.map.project = null;
    }

    this.map.width = value.width;
    this.map.height = value.height;
  }

  private getSunstudy(id: number): WidgetSunstudy {
    return this.sunstudies.find(v => v.id === +id);
  }

  save() {
    this.updateModel();

    this.mapService.update(this.map)
      .finally(() => {
      })
      .subscribe(map => {
        this.activeModal.close(map);
      });
  }

  close() {
    this.activeModal.dismiss();
  }

  init(widget: Widget, map: WidgetMap) {
    this.widget = widget;
    this.map = map;

    this.loadSunstudies();

    this.form.patchValue({
      type: this.map.type,
      name: this.map.name,
      width: this.map.width,
      height: this.map.height,
    });

    if (this.map.sunstudy) {
      this.form.patchValue({
        background: {
          type: WidgetMapBackground.Sunstudy,
          sunstudyId: this.map.sunstudy.id
        }
      });
    } else {
      this.form.patchValue({
        background: {
          type: WidgetMapBackground.Image,
          fileId: this.map.fileId
        }
      });
    }
  }

  private loadSunstudies() {
    if (this.sunstudies) return;

    this.sunstudiesPromise = new Promise(accept => {
      this.sunstudyService.get(this.widget).subscribe(studies => {
        this.sunstudies = studies;
        accept();
      })
    });
  }


  get opened() {
    return this.map;
  }

  get backgroundTypes() {
    return [
      WidgetMapBackground.Image,
      WidgetMapBackground.Sunstudy
    ];
  }

  typeName(type: WidgetMapBackground) {
    if (type === WidgetMapBackground.Image) {
      return 'Bild';
    } else {
      return 'Solstudie';
    }
  }

  mapTypeName(type: WidgetMapType) {
    if (type === WidgetMapType.Objects) {
      return 'Objekt-karta';
    } else if (type === WidgetMapType.Projects) {
      return 'Projekt-karta';
    } else if (type === WidgetMapType.Maps) {
      return 'Översikts-karta';
    }
  }

  get isImage() {
    return this.form.get('background.type').value === WidgetMapBackground.Image;
  }

  get isSunstudy() {
    return this.form.get('background.type').value === WidgetMapBackground.Sunstudy;
  }

  get uploadUrl() {
    return `${this.widget.url}/map-upload`;
  }

  cancelEditingImage() {
    this.isUploading = false;
    this.form.patchValue({
      background: {
        fileId: this.map.fileId
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/edit-map-modal/edit-map-modal.component.ts